$(function() {
  if (isMobile) {

    $('body').addClass('ism');

    $('button.header__cta--hamburger').click(function(e) {
      e.preventDefault();

      $('.header').toggleClass('header--mobile-open');
      $('body').toggleClass('ohns');
      $('.mobile-navigation').toggleClass('mobile-navigation--active');
      // $('.mobile-navigation').css('padding-top', $('.main-content').data('offset'));
    });

    // if ($(window).width() < 992) {
    //   $('.cart-box').css('top', $('.main-content').data('offset'));
    // }

  }

  $(window).resize(function() {
    if ($(window).width() < 992) {
      $('body').addClass('ism');
    } else {
      $('body').removeClass('ism');
    }
  });

});
